module.exports = __webpack_public_path__ + "img/przedruk-schemat-01-en.efd3e9eb.jpg";